import { defineStore } from "pinia";

export const useBeritaStore = defineStore("berita", {
  state: () => ({
 berita : [
  {
    id: 1,
    judul: "Khitanan Massal",
    gambar: "https://dinkes.kalteng.go.id/wp-content/uploads/2023/05/01-4.jpeg",
    kategori: "Akademik",
    catid: 1,
    slug_cat: "akademik",
    isi: "Khitanan telah dikenal oleh kalangan sebagai proses adat dan pembersihan diri sebelum beranjak dewasa. Masyarakat terdahulu menjaga budaya dan menganggap proses ini sangat penting.",
    tanggal: "2025-07-08",
    slug_berita: "khitanan-massal",
    penulis: "Admin FIKES",
    excerpt: "Khitanan dikenal sebagai proses adat dan pembersihan diri sebelum dewasa...",
    is_hero: true,
    created_time: "2025-07-08 15:09:22",
    modify_time: "2025-07-08 15:11:22",
  },
  {
    id: 2,
    judul: "Pengabdian Masyarakat di Desa Banyumas",
    gambar: "https://images.unsplash.com/photo-1593642532973-d31b6557fa68",
    kategori: "Pengabdian",
    catid: 2,
    slug_cat: "pengabdian",
    isi: "Mahasiswa dan dosen melakukan kegiatan pengabdian masyarakat berupa penyuluhan dan pemeriksaan kesehatan di Desa Banyumas.",
    tanggal: "2025-07-01",
    slug_berita: "pengabdian-banyumas",
    penulis: "Tim Pengabdian",
    excerpt: "Mahasiswa dan dosen terjun langsung dalam kegiatan penyuluhan kesehatan...",
    is_hero: true,
    created_time: "2025-07-01 15:09:22",
    modify_time: "2025-07-01 15:11:22",
  },
  {
    id: 4,
    judul: "Workshop Kesehatan Mental Remaja",
    gambar: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d",
    kategori: "Workshop",
    catid: 3,
    slug_cat: "workshop",
    isi: "Fakultas Psikologi menggelar workshop untuk meningkatkan kesadaran remaja terhadap pentingnya kesehatan mental.",
    tanggal: "2025-05-15",
    slug_berita: "workshop-kesehatan-mental",
    penulis: "Fakultas Psikologi",
    excerpt: "Kesadaran remaja terhadap isu kesehatan mental semakin penting di era modern...",
    is_hero: true,
    created_time: "2025-05-15 15:09:22",
    modify_time: "2025-05-15 15:11:22",
  },
  {
    id: 5,
    judul: "Ini Bukan Hero 1",
    gambar: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d",
    kategori: "Workshop",
    catid: 3,
    slug_cat: "workshop",
    isi: "Fakultas Psikologi menggelar workshop untuk meningkatkan kesadaran remaja terhadap pentingnya kesehatan mental.",
    tanggal: "2025-05-15",
    slug_berita: "workshop-kesehatan-mental",
    penulis: "Fakultas Psikologi",
    excerpt: "Kesadaran remaja terhadap isu kesehatan mental semakin penting di era modern...",
    is_hero: false,
    created_time: "2025-05-15 15:09:22",
    modify_time: "2025-05-15 15:11:22",
  },
  {
    id: 6,
    judul: "Ini Bukan Hero 2",
    gambar: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d",
    kategori: "Workshop",
    catid: 3,
    slug_cat: "workshop",
    isi: "Fakultas Psikologi menggelar workshop untuk meningkatkan kesadaran remaja terhadap pentingnya kesehatan mental.",
    tanggal: "2025-05-15",
    slug_berita: "workshop-kesehatan-mental",
    penulis: "Fakultas Psikologi",
    excerpt: "Kesadaran remaja terhadap isu kesehatan mental semakin penting di era modern...",
    is_hero: false,
    created_time: "2025-05-15 15:09:22",
    modify_time: "2025-05-15 15:11:22",
  },
  {
    id: 7,
    judul: "Seminar Nasional Kesehatan",
    gambar: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca",
    kategori: "Akademik",
    catid: 1,
    slug_cat: "akademik",
    isi: "Seminar nasional membahas isu-isu terbaru di bidang kesehatan.",
    tanggal: "2025-08-01",
    slug_berita: "seminar-nasional-kesehatan",
    penulis: "Admin Akademik",
    excerpt: "Seminar nasional membahas isu kesehatan terbaru...",
    is_hero: false,
    created_time: "2025-08-01 10:00:00",
    modify_time: "2025-08-01 10:30:00",
  },
  {
    id: 8,
    judul: "Kuliah Umum Profesi Kesehatan",
    gambar: "https://images.unsplash.com/photo-1506744038136-46273834b3fb",
    kategori: "Akademik",
    catid: 1,
    slug_cat: "akademik",
    isi: "Kuliah umum menghadirkan pembicara dari berbagai profesi kesehatan.",
    tanggal: "2025-08-05",
    slug_berita: "kuliah-umum-profesi-kesehatan",
    penulis: "Admin Akademik",
    excerpt: "Kuliah umum dengan pembicara profesi kesehatan...",
    is_hero: false,
    created_time: "2025-08-05 09:00:00",
    modify_time: "2025-08-05 09:30:00",
  },
  {
    id: 9,
    judul: "Lomba Karya Tulis Ilmiah",
    gambar: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308",
    kategori: "Akademik",
    catid: 1,
    slug_cat: "akademik",
    isi: "Lomba karya tulis ilmiah untuk mahasiswa kesehatan.",
    tanggal: "2025-08-10",
    slug_berita: "lomba-karya-tulis-ilmiah",
    penulis: "Admin Akademik",
    excerpt: "Lomba karya tulis ilmiah untuk mahasiswa...",
    is_hero: false,
    created_time: "2025-08-10 13:00:00",
    modify_time: "2025-08-10 13:30:00",
  },
  {
    id: 10,
    judul: "Diskusi Panel Pendidikan",
    gambar: "https://images.unsplash.com/photo-1465101178521-c1a9136a3c8b",
    kategori: "Akademik",
    catid: 1,
    slug_cat: "akademik",
    isi: "Diskusi panel membahas inovasi pendidikan kesehatan.",
    tanggal: "2025-08-15",
    slug_berita: "diskusi-panel-pendidikan",
    penulis: "Admin Akademik",
    excerpt: "Diskusi panel inovasi pendidikan kesehatan...",
    is_hero: false,
    created_time: "2025-08-15 14:00:00",
    modify_time: "2025-08-15 14:30:00",
  },
  {
    id: 11,
    judul: "Penyuluhan Gizi di Sekolah",
    gambar: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca",
    kategori: "Pengabdian",
    catid: 2,
    slug_cat: "pengabdian",
    isi: "Tim pengabdian melakukan penyuluhan gizi di sekolah dasar.",
    tanggal: "2025-09-01",
    slug_berita: "penyuluhan-gizi-sekolah",
    penulis: "Tim Pengabdian",
    excerpt: "Penyuluhan gizi untuk siswa sekolah dasar...",
    is_hero: false,
    created_time: "2025-09-01 08:00:00",
    modify_time: "2025-09-01 08:30:00",
  },
  {
    id: 12,
    judul: "Bakti Sosial Lansia",
    gambar: "https://images.unsplash.com/photo-1506744038136-46273834b3fb",
    kategori: "Pengabdian",
    catid: 2,
    slug_cat: "pengabdian",
    isi: "Bakti sosial untuk lansia di panti jompo.",
    tanggal: "2025-09-05",
    slug_berita: "bakti-sosial-lansia",
    penulis: "Tim Pengabdian",
    excerpt: "Bakti sosial untuk lansia di panti jompo...",
    is_hero: false,
    created_time: "2025-09-05 09:00:00",
    modify_time: "2025-09-05 09:30:00",
  },
  {
    id: 13,
    judul: "Pemeriksaan Kesehatan Gratis",
    gambar: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308",
    kategori: "Pengabdian",
    catid: 2,
    slug_cat: "pengabdian",
    isi: "Pemeriksaan kesehatan gratis untuk masyarakat desa.",
    tanggal: "2025-09-10",
    slug_berita: "pemeriksaan-kesehatan-gratis",
    penulis: "Tim Pengabdian",
    excerpt: "Pemeriksaan kesehatan gratis untuk masyarakat...",
    is_hero: false,
    created_time: "2025-09-10 10:00:00",
    modify_time: "2025-09-10 10:30:00",
  },
  {
    id: 14,
    judul: "Penyuluhan Kebersihan Lingkungan",
    gambar: "https://images.unsplash.com/photo-1465101178521-c1a9136a3c8b",
    kategori: "Pengabdian",
    catid: 2,
    slug_cat: "pengabdian",
    isi: "Penyuluhan kebersihan lingkungan di desa Banyumas.",
    tanggal: "2025-09-15",
    slug_berita: "penyuluhan-kebersihan-lingkungan",
    penulis: "Tim Pengabdian",
    excerpt: "Penyuluhan kebersihan lingkungan di desa...",
    is_hero: false,
    created_time: "2025-09-15 11:00:00",
    modify_time: "2025-09-15 11:30:00",
  },
  {
    id: 19,
    judul: "Workshop Pengembangan Diri",
    gambar: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca",
    kategori: "Workshop",
    catid: 3,
    slug_cat: "workshop",
    isi: "Workshop pengembangan diri untuk mahasiswa.",
    tanggal: "2025-11-01",
    slug_berita: "workshop-pengembangan-diri",
    penulis: "Fakultas Psikologi",
    excerpt: "Workshop pengembangan diri untuk mahasiswa...",
    is_hero: false,
    created_time: "2025-11-01 08:00:00",
    modify_time: "2025-11-01 08:30:00",
  },
  {
    id: 20,
    judul: "Workshop Public Speaking",
    gambar: "https://images.unsplash.com/photo-1506744038136-46273834b3fb",
    kategori: "Workshop",
    catid: 3,
    slug_cat: "workshop",
    isi: "Workshop public speaking untuk mahasiswa.",
    tanggal: "2025-11-05",
    slug_berita: "workshop-public-speaking",
    penulis: "Fakultas Psikologi",
    excerpt: "Workshop public speaking untuk mahasiswa...",
    is_hero: false,
    created_time: "2025-11-05 09:00:00",
    modify_time: "2025-11-05 09:30:00",
  },
  {
    id: 21,
    judul: "Workshop Mindfulness",
    gambar: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308",
    kategori: "Workshop",
    catid: 3,
    slug_cat: "workshop",
    isi: "Workshop mindfulness untuk kesehatan mental.",
    tanggal: "2025-11-10",
    slug_berita: "workshop-mindfulness",
    penulis: "Fakultas Psikologi",
    excerpt: "Workshop mindfulness untuk kesehatan mental...",
    is_hero: false,
    created_time: "2025-11-10 10:00:00",
    modify_time: "2025-11-10 10:30:00",
  },
  {
    id: 22,
    judul: "Workshop Manajemen Stres",
    gambar: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca",
    kategori: "Workshop",
    catid: 3,
    slug_cat: "workshop",
    isi: "Workshop manajemen stres untuk mahasiswa.",
    tanggal: "2025-11-15",
    slug_berita: "workshop-manajemen-stres",
    penulis: "Fakultas Psikologi",
    excerpt: "Workshop manajemen stres untuk mahasiswa...",
    is_hero: false,
    created_time: "2025-11-15 11:00:00",
    modify_time: "2025-11-15 11:30:00",
  },
  ...Array.from({ length: 60 }, (_, i) => ({
    id: 100 + i, // ID unik untuk data dummy
    judul: `Berita Akademik ${i + 1}`,
    gambar: "https://via.placeholder.com/150",
    kategori: "Akademik",
    catid: 1,
    slug_cat: "akademik",
    isi: `Konten berita akademik ${i + 1}.`,
    tanggal: "2025-07-21",
    slug_berita: `berita-akademik-${i + 1}`,
    penulis: "Admin Akademik",
    excerpt: `Ringkasan berita akademik ${i + 1}...`,
    is_hero: false,
    created_time: "2025-07-21 10:00:00",
    modify_time: "2025-07-21 10:30:00",
  })),
],
    currentIndex: 0,
  }),
  getters: {
    currentBerita: (state) =>
      state.berita.filter((item) => item.is_hero)[state.currentIndex],
    heroBerita: (state) => state.berita.filter((item) => item.is_hero),
  },
  actions: {
    next() {
      const heroCount = this.heroBerita.length;
      this.currentIndex = (this.currentIndex + 1) % heroCount;
    },
    prev() {
      const heroCount = this.heroBerita.length;
      this.currentIndex = (this.currentIndex - 1 + heroCount) % heroCount;
    },
    loadMoreBerita() {
      const additionalBerita = Array.from({ length: 10 }, (_, i) => ({
        id: this.berita.length + i + 1,
        judul: `Berita Tambahan ${this.berita.length + i + 1}`,
        gambar: "https://via.placeholder.com/150",
        kategori: "Tambahan",
        catid: 4,
        slug_cat: "tambahan",
        isi: `Konten berita tambahan ${this.berita.length + i + 1}.`,
        tanggal: "2025-07-21",
        slug_berita: `berita-tambahan-${this.berita.length + i + 1}`,
        penulis: "Admin Tambahan",
        excerpt: `Ringkasan berita tambahan ${this.berita.length + i + 1}...`,
        is_hero: false,
        created_time: "2025-07-21 10:00:00",
        modify_time: "2025-07-21 10:30:00",
      }));

      this.berita.push(...additionalBerita);
    },
  },
});
